module.exports = __webpack_public_path__ + "fonts/GT-Alpina-Fine-Standard-Regular-Italic.aaead448.woff";